var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCallBlack = function SvgIconCallBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 11.28v2a1.332 1.332 0 0 1-1.454 1.334 13.193 13.193 0 0 1-5.753-2.047 13 13 0 0 1-4-4 13.193 13.193 0 0 1-2.047-5.78A1.333 1.333 0 0 1 2.74 1.334h2A1.333 1.333 0 0 1 6.073 2.48a8.56 8.56 0 0 0 .467 1.874 1.333 1.333 0 0 1-.3 1.406l-.847.847a10.667 10.667 0 0 0 4 4l.847-.847a1.333 1.333 0 0 1 1.407-.3 8.561 8.561 0 0 0 1.873.467 1.334 1.334 0 0 1 1.147 1.353Z",
    fill: "#212121"
  })));
};
export default SvgIconCallBlack;